import React, { Component, memo } from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { IaCreators } from '../../../../../store/actions/intelligence';
import { BotsCreators } from '../../../../../store/actions/bots';

import actions from '../../../../../store/actions';
import './ConnectCreator.scss';
import { TOKENALL } from '../../../../../store/tokenApp';

class ConnectCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      region: 'westus',
      primaryWit: '',
      primaryLuis: '',
      host: '',
      language: 'pt-BR',
      isConfig: false,
      isActive: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.iaInfo !== this.props.iaInfo) {
      const ia =
        this.props.bot &&
        this.props.bot.ia &&
        this.props.bot.ia.platforms.find(
          (element) => element.platform === this.props.name
        );

      if (this.props.name === 'luis') {
        this.setState({
          primaryLuis: this.props.iaInfo.credentials.token || '',
          language: this.props.iaInfo.credentials.extra.language || '',
          host: this.props.iaInfo.credentials.extra.host || '',
          isConfig: true,
          isActive: ia.token === this.props.bot.currentTokenIa,
        });
      }

      if (this.props.name === 'wit') {
        this.setState({
          primaryWit: this.props.iaInfo.credentials.token || '',
          isConfig: true,
          isActive: ia.token === this.props.bot.currentTokenIa,
        });
      }

      if (this.props.name === 'boteria') {
        this.setState({
          isConfig: true,
          isActive: ia.token === this.props.bot.currentTokenIa,
        });
      }
    }

    if (prevProps.bot !== this.props.bot) {
      if (this.props.bot.currentTokenIa === '') {
        this.setState({
          isActive: false,
        });
      }
    }
  }

  changeSelect = (event) => {
    this.setState({
      region: event.target.value,
    });
  };

  changeSelectLanguage = (event) => {
    this.setState({
      language: event.target.value,
    });
  };

  create = () => {
    const { createLuis, createWit, createBoteria } = this.props;
    const { primaryWit, primaryLuis, language, host } = this.state;
    if (this.props.name === 'wit') {
      createWit('wit', { token: primaryWit }, this.props.bot._id, language);
    } else if (this.props.name === 'luis') {
      createLuis(
        'luis',
        { token: primaryLuis, host },
        this.props.bot._id,
        language
      );
    } else if (this.props.name === 'boteria') {
      createBoteria(
        'boteria',
        { token: process.env.WIT_TOKEN || TOKENALL.TOKEN_WIT },
        this.props.bot._id,
        language
      );
    }
  };

  inpChangeWit = (e) => {
    this.setState({
      primaryWit: e.target.value,
    });
  };

  inpChangeLuis = (e) => {
    this.setState({
      primaryLuis: e.target.value,
    });
  };

  inpChangeUrl = (e) => {
    this.setState({
      host: e.target.value,
    });
  };

  render() {
    const { name, bot, iaInfo } = this.props;

    return (
      <div className="container-creator">
        <div className="voltar-name-creator">
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => this.props.setConfig(false)}
          >
            {'<'}
          </span>{' '}
          <p> {this.props.name}</p>
        </div>

        {name === 'boteria' ? (
          <p className="p-inicar-creator">
            Para iniciar a ligação da Boteria clique em Connectar
          </p>
        ) : (
          <p className="p-inicar-creator">
            Para iniciar a ligação da Boteria com seu provedor IA é necessário o{' '}
            <span>login na plataforma</span>
          </p>
        )}

        <div className="container-campos">
          {name === 'wit' && (
            <div className="container-btn-duplo">
              <div className="dv-cog">
                <span>Primary key</span>
                <input
                  placeholder="chave"
                  onChange={this.inpChangeWit}
                  value={this.state.primaryWit}
                  disabled={this.state.isConfig ? 'disabled' : null}
                  type={this.state.isConfig ? 'password' : 'text'}
                />
              </div>
              <div>
                <span>Cultura</span>
                <select
                  value={this.state.language}
                  onChange={this.changeSelectLanguage}
                  disabled={this.state.isConfig ? 'disabled' : null}
                >
                  <option value="pt-BR">Português</option>
                  <option value="en-US">Inglês</option>
                  <option value="es-ES">Espanhol</option>
                </select>
              </div>
            </div>
          )}
          {name === 'luis' && (
            <>
              <div className="container-btn-duplo">
                <div className="dv-cog">
                  <span>Token</span>
                  <input
                    placeholder="chave"
                    onChange={this.inpChangeLuis}
                    value={this.state.primaryLuis}
                    disabled={this.state.isConfig ? 'disabled' : null}
                  />
                </div>
                <div>
                  <span>Região da aplicação</span>
                  <select
                    value={this.state.region}
                    onChange={this.changeSelect}
                    disabled={this.state.isConfig ? 'disabled' : null}
                  >
                    <option value="westus">West US</option>
                  </select>
                </div>
              </div>
              <div className="container-btn-duplo">
                <div className="dv-cog">
                  <span>URL do endpoint</span>
                  <input
                    placeholder="https://"
                    onChange={this.inpChangeUrl}
                    value={this.state.host}
                    disabled={this.state.isConfig ? 'disabled' : null}
                  />
                </div>
                <div>
                  <span>Cultura</span>
                  <select
                    value={this.state.language}
                    onChange={this.changeSelectLanguage}
                    disabled={this.state.isConfig ? 'disabled' : null}
                  >
                    <option value="pt-BR">Português</option>
                    <option value="en-US">Inglês</option>
                    <option value="es-ES">Espanhol</option>
                  </select>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="footer-creator">
          {/* <span>Documentação</span> */}
          <button onClick={this.create}>
            {!this.state.isConfig
              ? 'conectar e ativar'
              : this.state.isActive
              ? 'desativar'
              : 'ativar'}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  iaInfo: state.intelligence.iaInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(ConnectCreator)))
);
